import { INSTANCE_URL } from "@constant";
import { postRequest } from "@network";

export const TICKET_LIST = "TICKET_LIST";
export const EVENT_USER_CATEGORIES = "EVENT_USER_CATEGORIES";
export const MANGAE_TICKETS_COUNT = "MANGAE_TICKETS_COUNT";
export const ASSIGNED_ATTENDEE_TICKETS = "ASSIGNED_ATTENDEE_TICKETS";
export const ASSIGNED_ATTENDEE_ERRORS = "ASSIGNED_ATTENDEE_ERRORS";
export const APPLIED_COUPON = "APPLIED_COUPON";
export const APPLIED_COUPON_REMOVED = "APPLIED_COUPON_REMOVED";
export const ORDER_DATA = "ORDER_DATA";
export const OPENUSEREDIT_MODAL = "OPENUSEREDIT_MODAL";
export const ALLOW_CC_EMAILS = "ALLOW_CC_EMAILS";
export const ASSIGN_FLOW = "ASSIGN_FLOW";

export const clearTickets = (obj) => {
  return (dispatch) => {
    dispatch({ type: TICKET_LIST, payload: obj });
  };
};

export const fetchTickets = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...data, type: "getticket" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          dispatch({
            type: TICKET_LIST,
            payload: {
              data: response?.resource?.tickets ?? [],
              currency: response?.resource?.currency ?? [],
              tickettags: response?.resource?.tickettags ?? [],
              responsedata: response?.resource?.responsedata ?? {},
              hostlimit: response?.resource?.hostlimit ?? {},
              ...(response?.resource?.promoaccess
                ? { promoaccess: response.resource.promoaccess }
                : {}),
            },
          });
          callback({
            success: 1,
            data: response?.resource?.tickets ?? [],
            currency: response?.resource?.currency ?? [],
            tickettags: response?.resource?.tickettags ?? [],
            responsedata: response?.resource?.responsedata ?? {},
            hostlimit: response?.resource?.hostlimit ?? {},
            ...(response?.resource?.promoaccess
              ? { promoaccess: response.resource.promoaccess }
              : {}),
          });
        } else {
          dispatch({
            type: TICKET_LIST,
            payload: { error: response, data: [] },
          });
          callback({ success: 2, error: response, data: [] });
        }
      },
      (error) => {
        dispatch({ type: TICKET_LIST, payload: { data: [] } });
        callback({ success: 0 });
      }
    );
  };
};

export const fetchEventUserCategories = (session, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { eventid: session?.eventid, type: "getusercategory" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          dispatch({
            type: EVENT_USER_CATEGORIES,
            payload: { data: response?.resource },
          });
          callback({ success: 1, data: response?.resource });
        } else {
          dispatch({ type: EVENT_USER_CATEGORIES, payload: { data: [] } });
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const validateAssignedEmail = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...values, type: "validateemail" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          callback({ success: 1 });
        } else {
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const manageTicketCount = (tickets) => {
  return (dispatch) => {
    dispatch({ type: MANGAE_TICKETS_COUNT, payload: tickets });
  };
};

export const updateTicketAssignedAttendee = (data) => {
  return (dispatch) => {
    dispatch({ type: ASSIGNED_ATTENDEE_TICKETS, payload: data });
  };
};

export const updateTicketAssignedError = (data) => {
  return (dispatch) => {
    dispatch({ type: ASSIGNED_ATTENDEE_ERRORS, payload: data });
  };
};

export const applyPromo = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...data, type: "applycoupon" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          dispatch({ type: APPLIED_COUPON, payload: response?.resource ?? {} });
          callback({ success: 1, data: response?.resource ?? {} });
        } else {
          dispatch({ type: APPLIED_COUPON, payload: {} });
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const cancelPromo = (obj, isRemoved = false) => {
  return (dispatch) => {
    dispatch({ type: APPLIED_COUPON, payload: obj });

    if (isRemoved) {
      dispatch({ type: APPLIED_COUPON_REMOVED, payload: { removed: true } });
    }
  };
};

export const palceTicketOrder = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...data };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("action response :- ", response);
        if (response.success) {
          callback({ success: 1, data: response?.resource ?? {} });
        } else {
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        // console.log("action error :- ", error);
        callback({ success: 0, error: error });
      }
    );
  };
};

export function onlinePaymentConfirm(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...values, type: "payment_confirm" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          callback({ success: 1, data: response });
        } else {
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export const fetchSingleOrder = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...data, type: "getorderdetails" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          dispatch({
            type: ORDER_DATA,
            payload: { data: response?.resource ?? {} },
          });
          callback({ success: 1, data: response?.resource ?? {} });
        } else {
          dispatch({ type: ORDER_DATA, payload: { data: {} } });
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        dispatch({ type: ORDER_DATA, payload: { data: {} } });
        callback({ success: 0, error: error });
      }
    );
  };
};

export function clearOrderData() {
  return (dispatch) => {
    dispatch({ type: ORDER_DATA, payload: { data: {} } });
  };
}

export function ticketAssignReassign(session, data, callback) {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...data };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("action response :- ", response);
        if (response.success) {
          callback({ success: 1, data: response?.resource ?? {} });
        } else {
          callback({ success: 2, data: response });
        }
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export const openUserEditModal = (isopen = false) => {
  return (dispatch) => {
    dispatch({ type: OPENUSEREDIT_MODAL, payload: isopen });
  };
};

export const updateUserDetails = (session, value, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = {
    ...value,
    eventid: session?.eventid,
    type: "updateuserdetailsforOrder",
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        if (response.success) {
          callback({ success: 1, data: response });
        } else {
          callback({ success: 2, error: response });
        }
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const fetchAppuserDetails = (session, appuserid, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = {
    appuserid: appuserid,
    eventid: session.eventid,
    type: "getUserDetails",
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({
          success: response?.success,
          data: response?.resource?.data ?? [],
          sessions: response?.resource?.sessions ?? [],
        });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
};

export const updatedAllowCCEmails = (obj) => {
  return (dispatch) => {
    dispatch({ type: ALLOW_CC_EMAILS, payload: obj });
  };
};
export const updateAssignFlow = (obj) => {
  return (dispatch) => {
    dispatch({ type: ASSIGN_FLOW, payload: obj });
  };
};
